import { render, staticRenderFns } from "./paginator.vue?vue&type=template&id=cce785d6&scoped=true&"
import script from "./paginator.vue?vue&type=script&lang=js&"
export * from "./paginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce785d6",
  null
  
)

export default component.exports